import { render, staticRenderFns } from "./CustomNavButton.vue?vue&type=template&id=9923b362&scoped=true"
import script from "./CustomNavButton.vue?vue&type=script&lang=js"
export * from "./CustomNavButton.vue?vue&type=script&lang=js"
import style0 from "./CustomNavButton.vue?vue&type=style&index=0&id=9923b362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923b362",
  null
  
)

export default component.exports